import React from 'react';
import './index.less';
import {
    DownloadCsv,
    DownloadPdf,
    DownloadXls,
    WeatherDownloadIcon,
    WeatherTxtFormatIcon
} from '@/resource/IconComponentSets';

// 'XLS' | 'XLSX | PDF | CSV'

interface IProps {
    selectSpecifyType: (type: 'XLS' | 'XLSX' | 'PDF' | 'CSV' | 'JSON' | 'txt') => void
    cacncelDownload: () => void
    className: string
    titles: ('XLS' | 'XLSX' | 'PDF' | 'CSV' | 'JSON' | 'Data Excel' | 'API Query')[]
}
interface IMapObj {
    XLS: 'XLS',
    XLSX: 'XLSX',
    PDF: 'PDF',
    CSV: 'CSV',
    JSON: 'JSON',
    'Data Excel': 'XLSX',
    'API Query': 'txt'
}

export default function Download(props: IProps) {
    const {
        selectSpecifyType,
        className,
        titles
    } = props;

    const mapToTypeObj: IMapObj = {
        XLS: 'XLS',
        XLSX: 'XLSX',
        PDF: 'PDF',
        CSV: 'CSV',
        JSON: 'JSON',
        'Data Excel': 'XLSX',
        'API Query': 'txt'
    };

    return (
        <div className={`download-container ${className}`}>
            {/* <div className='title-div'>
                Choose file format
            </div> */}
            <div className='file-format-div'>
                <div className='format-div' key='pdf-1'>
                    {titles.map((title) => (
                        <div key={`${title}`} className='format-inner-div' onClick={() => selectSpecifyType( mapToTypeObj[title])}>
                            {title === 'Data Excel' && <DownloadXls />}
                            {title === 'API Query' && <WeatherTxtFormatIcon />}
                            <span>{title}</span>
                        </div>
                    ))}
                    {/* <div key='csv' className='format-inner-div' onClick={() => selectSpecifyType('CSV')}>
                        <DownloadCsv />
                        <span>CSV</span>
                    </div> */}
                    {/* <div className='format-inner-div' onClick={() => selectSpecifyType('XLS')}>
                        <DownloadXls />
                        <span>XLS</span>
                    </div> */}
                </div>
                {/* <div className='format-div' key='xlsx-3'>
                    <div className='format-inner-div' onClick={() => selectSpecifyType('XLSX')}>
                        <DownloadXls />
                        <span>XLS</span>
                    </div>
                </div> */}
            </div>
            {/* <div className='cancel-div'>
                <SoilButton type='always' highLight='default' className='cancel-button' onClick={cacncelDownload}>
                    Cancel
                </SoilButton>
            </div> */}
        </div>
    );
}